import React from "react";
import { SearchBox } from "@quintype/components";
import SearchIcon from "../../atoms/icons/search-icon";
import "./search.m.css";

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearchFormOpen: false
    };
  }

  componentDidMount() {
    document.getElementById("searchFormMobile").autofocus = "false";
    document.getElementById("searchFormNonMobile").autofocus = "false";
  }

  toggleSearchForm() {
    this.setState({ isSearchFormOpen: !this.state.isSearchFormOpen }, () => {
      // TODO use ref instead of getElementbyId
      document.getElementById("searchFormMobile").focus();
      document.getElementById("searchFormNonMobile").focus();
    });
  }

  render() {
    const formStyle = {
      width: this.state.isSearchFormOpen ? "265px" : "25px",
      borderBottom: this.state.isSearchFormOpen
        ? "1px solid rgba(255, 255, 255, 0.8)"
        : "1px solid rgba(255, 255, 255, 0.01)"
    };
    return (
      <React.Fragment>
        <div styleName="search-stories-component search-stories-component-sm">
          <SearchIcon className="search-stories-component-icon" onClick={() => this.toggleSearchForm()} height={35} />
          <SearchBox
            styleName={`search-stories-component-form ${this.state.isSearchFormOpen ? "is-open" : ""}`}
            template={DrawForm}
            inputId="searchFormMobile"
            inputRef={input => (this.input = input)}
            inputstyleName="search-stories-component-orm-input"
            formRef={searchForm => (this.searchForm = searchForm)}
            onSubmitHandler={() => this.setState({ isSearchFormOpen: false })}
            onEscape={() => this.setState({ isSearchFormOpen: false })}
            placeholder="Type to search"
          />
        </div>
        <div styleName="search-stories-component search-stories-component-lg" style={formStyle}>
          <SearchIcon className="search-stories-component-icon" onClick={() => this.toggleSearchForm()} height={35} />
          <SearchBox
            styleName="search-stories-component-form"
            template={DrawForm}
            inputId="searchFormNonMobile"
            inputRef={input => (this.input = input)}
            inputClassName="search-stories-component-form-input"
            formRef={searchForm => (this.searchForm = searchForm)}
            onSubmitHandler={() => this.setState({ isSearchFormOpen: false })}
            onEscape={() => this.setState({ isSearchFormOpen: false })}
            placeholder="Type to search"
          />
        </div>
      </React.Fragment>
    );
  }
}

function DrawForm({ children }) {
  return [
    <label className="search-stories-component__form-label" htmlFor="searchForm" key="1">
      {children}
    </label>
  ];
}

export { Search };
